import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  toggleFormContainer: {
    position: 'relative',
  },
  toggleCloseButton: {
    position: 'absolute',
    color: theme.palette.neutralDark,
    right: pxToRem(15),
    top: pxToRem(10),
    selectors: {
      ':hover': {
        color: theme.palette.themeDarker,
      },
    },
  },
  selectButtonDefault: {
    marginLeft: pxToRem(480),
  },
  selectButtonSelected: {
    marginLeft: pxToRem(480),
  },
  moduleHeader: {
    selectors: {
      '.ms-Button--default': {
        maxWidth: 'none',
      },
    },
  },
  root: {
    backgroundColor: theme.palette.white,
    position: 'relative',
    padding: pxToRem(14),
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
  },
  saveProductIdButton: {
    position: 'absolute',
    right: pxToRem(1),
    top: pxToRem(40),
  },
  productData: {
    fontSize: pxToRem(14),
    fontWeight: 400,
    color: theme.palette.neutralPrimary,
  },
  desktopRemoveButton: {
    display: 'inline-block',
    height: 'auto',
    top: pxToRem(6),
  },
  editButton: {
    display: 'inline-block',
    marginLeft: pxToRem(48),
    height: 'auto',
    top: pxToRem(6),
  },
  productList: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: pxToRem(3),
    paddingBottom: pxToRem(3),
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
    fontSize: pxToRem(14),
    fontWeight: 400,
    font: 'SegoeUI',
  },
  bundledProducts: {
    selectors: {
      '& .ms-DetailsRow-cell[data-automation-key="productId"]': {
        padding: 0,
      },
    },
    overflow: 'hidden',
    paddingBottom: pxToRem(16),
  },
  datePicker: {
    width: '100%',
  },
});
